var Handlebars = require("../../../../node_modules/handlebars/runtime.js");
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"1":function(container,depth0,helpers,partials,data) {
    var lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "        <div class=\"cell-description\">"
    + container.escapeExpression(__default(require("../../helpers/truncate.js")).call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"description") : depth0),45,{"name":"truncate","hash":{},"data":data,"loc":{"start":{"line":12,"column":38},"end":{"line":12,"column":65}}}))
    + "</div>\n";
},"3":function(container,depth0,helpers,partials,data) {
    return "        <div class=\"cell-description empty\">Add Description</div>\n";
},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<div data-behavior=\"open-modal\">\n    <button class=\"cell-control edit\" data-behavior=\"edit\">\n        <i class=\"edit-icon\"></i>\n        <span class=\"sr-only\">Edit Item</span>\n    </button>\n    <button class=\"cell-control destroy\" data-behavior=\"destroy\">\n        <i class=\"delete-icon\"></i>\n        <span class=\"sr-only\">Delete Item</span>\n    </button>\n    <div class=\"cell-name\">"
    + container.escapeExpression(container.lambda((depth0 != null ? lookupProperty(depth0,"cellName") : depth0), depth0))
    + "</div>\n"
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"description") : depth0),{"name":"if","hash":{},"fn":container.program(1, data, 0),"inverse":container.program(3, data, 0),"data":data,"loc":{"start":{"line":11,"column":4},"end":{"line":15,"column":11}}})) != null ? stack1 : "")
    + "</div>\n";
},"useData":true});